module.exports = __webpack_public_path__ + "img/27851d794d8aca96d10827ad4f2f5f41.png";